@if (isLoading) {
  <wl-loading />
} @else {
  <wl-masonry [items]="masonryItems"></wl-masonry>
}
